import { el } from "./dom";

export interface CrestButtonOptions {
  readonly label: string;
  readonly sub?: string;
  readonly primary?: boolean;
  readonly small?: boolean;
  readonly disabled?: boolean;
  readonly onClick?: () => void;
}

export function createCrestButton(opts: CrestButtonOptions): HTMLButtonElement {
  const classes = ["crest-btn"];
  if (opts.primary) classes.push("crest-btn--primary");
  if (opts.small) classes.push("crest-btn--small");

  const children: (HTMLElement | string)[] = [opts.label];
  if (opts.sub) {
    children.push(el("span", { class: "crest-btn__sub", text: opts.sub }));
  }

  const btn = el("button", {
    class: classes.join(" "),
    attrs: { type: "button" },
    on: opts.onClick ? { click: () => opts.onClick?.() } : undefined,
  }, children);

  if (opts.disabled) {
    btn.disabled = true;
  }
  return btn;
}
